import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, InputGroup } from 'react-bootstrap';
import axios from 'axios';
import user from '../../assets/image 1.png';
import Cookies from 'js-cookie';

const Communication = () => {
  const [message, setMessage] = useState('');
  const [file, setFile] = useState(null);
  const [messages, setMessages] = useState([]);
  const teacherId = Cookies.get('teacherId'); 

  useEffect(() => {
    // Function to fetch messages
    const fetchMessages = async () => {
      try {
        const response = await axios.get('https://backend.writerswright.com/api/v1/teacher/getCommunication');
        setMessages(response.data);
      } catch (error) {
        console.error('Error fetching messages:', error);
      }
    };

    fetchMessages();

    const interval = setInterval(fetchMessages, 100);

    return () => {
      clearInterval(interval);
    };
  }, []); 

  const handleSendMessage = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('message', message);
    formData.append('file', file);
    formData.append('teacherId', teacherId);

    try {
      const response = await axios.post('https://backend.writerswright.com/api/v1/teacher/communication', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log(response.data); // Handle the response as needed
      setMessage(''); // Clear the message input
      setFile(null); // Clear the file input
    } catch (error) {
      console.error('Error sending message:', error);
      alert('Failed to send message. Please try again.');
    }
  };
  return (
    <Container className="mt-5">
      <Row>
        <Col>
          <h2>General Communication Group</h2>
        </Col>
      </Row>
      <Row className="chat-box mt-3" style={{ border: '1px solid #ccc', borderRadius: '5px', height: '400px', overflowY: 'scroll', padding: '10px' }}>
        <Col>
          {messages.map((msg, index) => (
            <div key={index} className="message" style={{ textAlign: msg.teacherId === parseInt(teacherId) ? 'left' : 'right' }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: msg.teacherId === parseInt(teacherId) ? 'flex-start' : 'flex-end' }}>
                <div><img src={user} alt="" style={{ width: "43px", height: "43px" }} /></div>
                <div>
                  <strong>{msg.teacherId === parseInt(teacherId) ? 'ME' : msg.Name}</strong>
                  <p>{msg.message}</p>
                  {msg.file && <img src={msg.file} alt="Attachment" style={{ width: "100px", height: "100px" }} />}
                </div>
              </div>
              <small className="text-muted">{new Date(msg.dated).toLocaleString()}</small>
            </div>
          ))}
        </Col>
      </Row>
      <Form onSubmit={handleSendMessage}>
        <Row className="mt-3">
          <Col>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Enter Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </InputGroup>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <Form.Group controlId="formFile">
              <Form.Control
                type="file"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-end"> {/* Right align the button */}
            <button className='button-37 mt-2' type="submit">
              Send
            </button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default Communication;
